export type AppRole = 'ADMIN' | 'GESTAO'

export interface UserProfile {
  active: boolean
  must_change_password: boolean
  full_name: string
  id: string
  role: AppRole
}

export function canManageUsers(profile: UserProfile): boolean {
  return profile.active && profile.role === 'ADMIN'
}

export function canWriteOperationalData(profile: UserProfile): boolean {
  return profile.active && profile.role === 'ADMIN'
}

export function canViewIndicators(profile: UserProfile): boolean {
  return profile.active
}
